var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntDesignWarningFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3998 20.0625L12.6498 3.1875C12.5045 2.93672 12.2537 2.8125 12.0006 2.8125C11.7475 2.8125 11.4943 2.93672 11.3514 3.1875L1.60138 20.0625C1.31309 20.5641 1.67403 21.1875 2.25059 21.1875H21.7506C22.3272 21.1875 22.6881 20.5641 22.3998 20.0625ZM11.2506 9.75C11.2506 9.64687 11.335 9.5625 11.4381 9.5625H12.5631C12.6662 9.5625 12.7506 9.64687 12.7506 9.75V14.0625C12.7506 14.1656 12.6662 14.25 12.5631 14.25H11.4381C11.335 14.25 11.2506 14.1656 11.2506 14.0625V9.75ZM12.0006 18C11.7062 17.994 11.4259 17.8728 11.2198 17.6625C11.0137 17.4522 10.8983 17.1695 10.8983 16.875C10.8983 16.5805 11.0137 16.2978 11.2198 16.0875C11.4259 15.8772 11.7062 15.756 12.0006 15.75C12.295 15.756 12.5753 15.8772 12.7814 16.0875C12.9874 16.2978 13.1029 16.5805 13.1029 16.875C13.1029 17.1695 12.9874 17.4522 12.7814 17.6625C12.5753 17.8728 12.295 17.994 12.0006 18Z",
    fill: "#F24545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignWarningFilled);
export default __webpack_public_path__ + "static/media/ant-design_warning-filled.a4f9ce0a32d4782a751d533e75db8918.svg";
export { ForwardRef as ReactComponent };